import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

import { Figure } from "~/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "~/components/content/content-headline/styles";
import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  display: block;

  color: #000000;
`;

export const Container = styled.div`
  display: grid;
  grid:
    "section" min-content
    "headline" min-content
    "summary" min-content
    "action-bar" min-content
    / 100%;

  :hover {
    ${ContentHeadline}, ${SponsorHeadline} {
      color: #2c4692;
    }
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "section cover-image" min-content
      "headline cover-image" min-content
      "summary cover-image" min-content
      "action-bar cover-image" min-content
      / minmax(0, 1fr) minmax(0, 216px);

    column-gap: 32px;
  }
`;

export const Section = styled.div`
  grid-area: section;

  margin-block-end: 8px;

  color: #4585ff;
  font-weight: 700;
  font-size: 13px;
  font-family: ${fontRobotoCondensed};
  line-height: 120%;
  text-transform: uppercase;
`;

export const Headline = styled.div`
  grid-area: headline;

  margin-block-end: 12px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 20px;
  }
`;

export const Summary = styled.div`
  grid-area: summary;

  display: none;

  margin-block-end: 12px;

  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 130%;

  font-feature-settings: "clig" off, "liga" off;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }

  ${StyledEntityLink} {
    color: #6f6f6f;
  }
`;

export const ActionBar = styled.div`
  grid-area: action-bar;

  time {
    color: #999999;
    font-weight: 400;
    font-size: 12px;
    font-family: ${fontRoboto};
    line-height: 120%;
  }
`;

export const CoverImage = styled.div`
  grid-area: cover-image;

  display: none;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }

  ${Figure} {
    aspect-ratio: 3/2;

    max-inline-size: 216px;
    max-block-size: 144px;
  }
`;
